export enum LineSeparatorStyle {
    NORMAL = "Normal",
    BOLDER = "Bolder"
};